export default __webpack_public_path__ + "static/1-11898bbacb1170ee2e107462d87f2b27.png";